// import { Control, Field, Form, Label, Logo, Message, Name, Tagline } from '../styles/login.style'

import {
  FormControl,
  FormField,
  FormMessage,
  Root as FormRoot,
  FormSubmit,
} from '@radix-ui/react-form'

import { styled } from './stitches.config'
import { DivInput } from '../components/profile/DivInput';
import { Button } from './_app.style';
import { useScale } from '../pages/HeightScaler';
import { FaQuestionCircle, FaTimes } from 'react-icons/fa';

const VIEWPORT = 400; // Crop container size (square)


export const Header = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 48,

  /* reserve the button’s width on both sides */
  padding: '0 200px',         // 44 px = 36 px icon + 2×4 px gap
});

export const Header3 = styled('div', {
  position: 'relative',
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  height: 48,
  marginTop: '1rem',

  /* reserve the button’s width on both sides */
  padding: '0 400px',         // 44 px = 36 px icon + 2×4 px gap
});


export const Header2 = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 48,

  /* reserve the button’s width on both sides */
});

export const BackButton = styled('button', {
  all: 'unset',
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  padding: '0 4px',
  cursor: 'pointer',


  '& svg': {
    stroke: 'black',     // default grey
  },

  '&:hover': {
    '& svg': {
      stroke: '$separator',
    },
  },

});


/* flush-left arrow */

/* perfectly centred title */
export const Name = styled('span', {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',   // centre on both axes
  fontWeight: 600,
  fontSize: '1.5rem',
});


export const Input = styled('input', {
  all: 'unset',
  boxSizing: 'border-box',
  width: '100%',
  border: '1px solid $elementBorder',
  borderRadius: '0.5rem',
  padding: '0.75rem',
  height: '2.75rem',
  backgroundColor: 'white',
  transition: 'background-color 0.3s ease-in-out',
  '&::placeholder': {
    color: '$sand8',
  },
  '&:hover': {
    borderColor: '$elementHoverBorder',
  },
  '&:focus': {
    borderColor: '$solidBackground',
  },
})

export const Logo = styled('img', {
  height: '4.5rem',
  marginBottom: '1rem',
  marginTop: '1rem',
  userSelect: 'none',
  '-moz-user-select': 'none',
  '-webkit-user-select': 'none',
})

// export const Name = styled('h1', {
//   margin: 0,
//   fontWeight: 600,
// })

export const Tagline = styled('p', {
  color: '$lowContrast',
})

export const LoginWrapper = styled('div', {
  backgroundColor: '$white',
  // width: `calc(100vw / ${scale}`,
  // height: `calc(100vh / ${scale}`,
  position: 'relative',      // sit above any grid lines
  zIndex: 1,
})

// somewhere in your stitches.config.ts (or a shared file)
export const IconButton = styled('button', {
  all: 'unset',          // remove all user-agent button styles
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,            // no extra hit-area, size comes from icon
})




export const RegisterArea = styled ('main', {
  position: 'relative',
  gridTemplateRows: 'auto 1fr',
  gridTemplateAreas: `
      "stepper"
      "form"
  `,
})


export const StepperArea = styled('div', {
  gridArea: 'stepper',
  zIndex: 3,
  top: 0,
  left: 0, 
  // background: 'green',
  flexShrink: '0',

  paddingLeft: '2.5rem', 

  position: 'sticky',
  height: '3.5rem',               // "a couple of rem long"
});


export const FormArea  = styled('div', {
  paddingTop: '1rem',
  padding: '1rem',
  flex: 1,
  minHeight: 0,         // <-- allow inner scroll instead of overflow
  display: 'flex',
  alignItems: 'center', 
  justifyContent: 'center',
  gridArea: 'form',
  width: '100%',
  boxSizing: 'border-box', // Ensures padding is included in the element's total height

  
});



export const Form = styled(FormRoot, {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  alignItems: 'center',
  backgroundColor: '$subtleBackground',
  padding: '1rem',
  borderRadius: '1rem',
  minHeight: 0,         // <-- important when nested in flex
  // height: '100%',

  overflow: 'hidden',   // <-- move scrolling to StepContent
  border: '0.0625rem solid $separator',
  maxHeight: '100%',


  variants: {
    size: {
      sm: { maxWidth: '50rem' },
      lg: { 
        maxWidth: '56rem', 
        width: '100%', 
        
        // **THIS** is the missing piece
      },          // new wide flavour
    },
  },
  defaultVariants: { size: 'sm' },
  minWidth: '20rem',

  fontSize: '$sm',

})



export const StepContent = styled('div', {
  width: '100%',
  gap: '1rem',
  flex: '1 1 auto', // Allows this area to grow and shrink
  minHeight: 0,         // <-- critical in flex layouts
  overflow: 'auto',     // <-- put the scroll her
  padding: '0.5rem 0.4rem', 
});

// For the sticky footer/button area
export const FormActions = styled('div', {
  flexShrink: 0, // Prevents this area from shrinking
  width: '100%', // Ensure it takes the full width of the form padding
  padding: '1.5rem 0 0 0', // Space above the button
  marginTop: 'auto', // Pushes it to the bottom if content is short
  borderTop: '1px solid $separator',
  textAlign: 'center',

});

// In your Stitches style file

// 👇 ADD THIS NEW COMPONENT
export const StepFormWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem', // All your field spacing logic lives here!
});

// ... keep all your other styled components


export const Field = styled(FormField, {
  all: 'unset',
  display: 'grid',
  // display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  alignItems: 'flex-start',
  width: '100%',
  variants: {
    horizontal: {
      true: {
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
  },
})
export const Label = styled('label', {
  textAlign: 'right',
})
export const Message = styled(FormMessage, {
  color: '$red10',
})

export const Control = styled(FormControl, {
  all: 'unset',
  boxSizing: 'border-box',
  width: '100%',
  border: '1px solid $elementBorder',
  borderRadius: '0.5rem',
  padding: '0.75rem',
  height: '2.75rem',
  backgroundColor: 'white',
  transition: 'background-color 0.3s ease-in-out',
  '&::placeholder': {
    color: '$sand8',
  },
  '&:hover': {
    borderColor: '$elementHoverBorder',
  },
  '&:focus': {
    borderColor: '$solidBackground',
  },
})

export const Submit = styled(FormSubmit, {
  padding: '2em',
})


export const TagWrap = styled('div', {
  display: 'flex', flexWrap: 'wrap', gap: '0.25rem',
  width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box',
})
export const Tag = styled('span', {
  display: 'inline-flex', alignItems: 'center', gap: '0.25rem',
  backgroundColor: '$elementBackground', borderRadius: '0.375rem',
  padding: '0.25rem 0.5rem', fontSize: '$sm',
  maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
})
export const Remove = styled('button', {
  all: 'unset', cursor: 'pointer', '&:hover': { color: '$dangerBackground' },
})

export const InlineWrapper = styled('div', {
  position: 'relative',
  width: '100%',
});

/* bottom layer ─ grey suggestion on white */
export const GhostControl = styled(Control, {
  position: 'absolute',
  inset: 0,                       // top:0 right:0 bottom:0 left:0
  zIndex: 0,
  backgroundColor: '#fff',        // <- white backdrop
  borderColor: 'transparent',
  color: '$elementBorder',        // grey text
  caretColor: 'transparent',
  pointerEvents: 'none',          // let clicks pass through
});

/* top layer ─ where the user types */
export const OverlayControl = styled(Control, {
  position: 'relative',           // keeps it in normal flow
  zIndex: 1,
  backgroundColor: 'transparent', // see-through so white shows
  color: '$text',                 // your normal input colour
});


// Add these new definitions

// A base style for any div that should look like an input
const baseInputStyle = {
  boxSizing: 'border-box',
  fontSize: '$sm',
  width: '100%',
  border: '1px solid $elementBorder',
  borderRadius: '0.5rem',
  padding: '0.75rem',
  height: '2.75rem',
  backgroundColor: '$appBackground',
  '&:focus': { outline: 'none' }, // Focus styles will be on the wrapper
};

/* The new GhostDiv for displaying the grey suggestion text */
export const GhostDiv = styled('div', {
  ...baseInputStyle, // Inherit the base look
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  backgroundColor: '#fff',
  borderColor: 'transparent',
  color: '$elementBorder',
  pointerEvents: 'none', // Clicks pass through to the input below
});

/* A styled version of our new DivInput component */
export const EditableOverlayDiv = styled(DivInput, {
  ...baseInputStyle, // Inherit the base look
  position: 'relative',
  zIndex: 1,
  backgroundColor: 'transparent', // See-through to the GhostDiv below
  color: '$text',
});

/* bottom layer – grey text on solid white */
export const GhostTextarea = styled(Control, {
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  backgroundColor: '#fff',
  borderColor: 'transparent',
  color: '$elementBorder',
  caretColor: 'transparent',
  pointerEvents: 'none',
  resize: 'none',          // ignore drag handle
});

/* top layer – the textarea the user edits */
export const OverlayTextarea = styled(Control, {
  position: 'relative',
  zIndex: 1,
  backgroundColor: 'transparent',
  color: '$text',
  resize: 'vertical',
});

/* ────────── STYLED COMPONENTS ───────── */
// export const CropContainer = styled('div', {
//   position: 'relative',
//   width: `${VIEWPORT}px`,
//   height: `${VIEWPORT}px`,
//   background: '$elementBackground',
//   overflow: 'hidden',
//   border: '2px dashed $elementBorder',
// });

export const CropContainer = styled('div', {
  position: 'relative',
  background: '$elementBackground',
  overflow: 'hidden',
  border: '2px dashed $elementBorder',

  // --- 👇 The Responsive Fix ---
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '400px', // Set a max-width so it doesn't get huge
  margin: '0 auto',  // Center the block if the container is wider than maxWidth
  aspectRatio: '1 / 1', // Modern CSS to maintain a perfect square!
});

// export const ZoomWrapper = styled('div', {
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '0.5rem',
//   width: `${VIEWPORT}px`,        // ← force it to be 400px wide
// });

export const ZoomWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',

  // --- 👇 The Responsive Fix ---
  width: '100%',
  variants: {
    profile: {
      false: {
        maxWidth: '400px', // Match the CropContainer's max-width
        
      }
    }
  },
  defaultVariants: {
    profile: 'false',
  },
  margin: '0 auto',  // Center it as well
});

export const ZoomLabel = styled('p', {
  fontSize: '$sm',
  marginBottom:'0.25rem'
});


export const PreviewWrap = styled('div', {
  mt: '1.5rem',
  overflowX: 'auto',          // mobile safety
});

export const Grid = styled('div', {
  display: 'grid',
  border: '1px solid $elementBorder',
  minWidth: 'max-content',
  borderRadius: 8,
  overflow: 'hidden',
  fontSize: '$sm',
});

export const Cell = styled('div', {
  p: '0.5rem',
  borderBottom: '1px solid $elementBorder',
  borderRight: '1px solid $elementBorder',
  textAlign: 'center',
  fontSize: '$sm',

  variants: {
    header: { true: { fontWeight: 600, background: '$elementBackground' } },
    ticked: { true: { color: '$accentText', background: '$accentBackground' } },
  },
});


export const PreviewViewport = styled('div', {
  width: '100%',

  maxWidth: '100%',

  overflowX: 'auto',
  overflowY: 'hidden',

  /* smoother iOS momentum scrolling */
  WebkitOverflowScrolling: 'touch',

  /* optional: some breathing-room and border */
  mt: '1.5rem',
  border: '1px solid $elementBorder',
  borderRadius: 8,
});

export const StandaloneFieldWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});

export const LoadingOverlay = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // You must use camelCase for properties and strings for values
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  borderRadius: '50%',
  zIndex: 10,
});



export const GroupContainer = styled('div', {
  width: '100%',
  border: '1px solid $elementBorder',
  borderRadius: '0.5rem',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  position: 'relative',
});

export const GroupHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1rem',
//   backgroundColor: '$blueWeeks'
});

export const GroupTitle = styled('h3', {
  fontSize: '$lg',
  fontWeight: 600,
  margin: 0,
});


export const EntryRow = styled('div', {
  // --- 1. DEFAULT (MOBILE CARD LAYOUT) ---
  display: 'grid',
  gap: '0.75rem',
  width: '100%',
  marginBottom: '1rem',
  
  // Card Look: Border, rounded corners, padding
  background: '$subtleBackground',
  border: '1px solid $elementBorder',
  borderRadius: '8px',
  padding: '1rem',
  
  // Stacked Layout: 
  // Row 1: Subject (Full width)
  // Row 2: Grade (Left) + Trash (Right)
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',

  // Force Subject to span the full top row
  '& > *:nth-child(1)': {
    gridColumn: '1 / -1',
    marginBottom: '0.25rem', // Tiny buffer between subject and grade row
  },


  // --- 2. DESKTOP / TABLET (YOUR ORIGINAL LAYOUT) ---
  '@media (min-width: 600px)': {
    // Restore your exact original grid columns
    gridTemplateColumns: '1fr auto 44px',
    
    // Restore your original gap and margin
    gap: '1rem',
    marginBottom: '0.75rem',
    
    // STRIP THE CARD STYLES
    border: 'none',
    borderRadius: '0',
    background: 'transparent',
    padding: 0,
    
    // Reset Subject to sit normally in column 1
    '& > *:nth-child(1)': {
      gridColumn: 'auto',
      marginBottom: 0,
    },
  },
});

export const AddSection = styled('div', {
  display: 'flex',
  gap: '0.75rem',
  marginBottom: '2rem',

  border: '1px dashed $elementBorder', // Dashed border signals "insert here"
  borderRadius: '8px',
  padding: '1.25rem',                // Give it internal breathing room
  backgroundColor: '$subtleBackground', // Optional: very faint gray background


  flexDirection: 'column', // Stack them vertically
  alignItems: 'stretch',   // Force both to be full width
  width: '100%',           // Ensure the container fits the parent
  boxSizing: 'border-box', // Critical so padding doesn't widen the element
  // --- 💻 DESKTOP (Side-by-Side) ---
  '@media (min-width: 600px)': {
    flexDirection: 'row',  // Put them back on one line
    alignItems: 'center',
  },

});

export const LightButton = styled(Button, {
  boxShadow: 'none',
  backgroundColor: '$slate3',
  fontSize: '$sm',
  color: 'black',
  
  // 1. Force the button itself to be 100% width of its container
  width: '100%', 
  
  // 2. Ensure content inside is centered (or 'flex-start' if you want left-align)
  display: 'flex',
  justifyContent: 'flex-start', 
  // alignItems: 'flex-start',

  '&:hover': {
      backgroundColor: '$slate3',
  },

  // 3. Reset for Desktop if you want it to shrink back down
  '@media (min-width: 600px)': {
     width: 'auto',   // Let it shrink to content size
     flexGrow: 1,     // Or keep your flex-grow logic
  }
});

export const TotalScoreContainer = styled('div', {
    marginTop: '1.5rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid $elementBorder',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr', // This creates 3 equal columns
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '1rem',
});

export const TotalScoreLabel = styled('span', {
    fontSize: '$sm',
    fontWeight: 600,
});

export const TotalScoreValue = styled('span', {
    fontSize: '$lg',
    fontWeight: 700,
    color: '$blue11',
    minWidth: '40px',
    textAlign: 'center',
});

export const TotalScoreBreakdown = styled('span', {
    fontSize: '$sm',
    color: '$slate11',
});


export const RateDisplay = styled('div', {
  textAlign: 'left',
  fontSize: '$2xl',
  fontWeight: '600',
//   color: '$blue11',
  padding: '1rem 0',
  background: '$mauve2',
  borderRadius: '8px',
  border: '1px solid $mauve6',
  marginBottom: '1.5rem',
//   marginTop: '1.5rem',
  fontVariantNumeric: 'tabular-nums',
});

export const OptionsContainer = styled('div', {
  // marginTop: '2rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

export const CheckboxWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  // padding: '1rem',
  background: '$mauve2',
  borderRadius: '8px',
  border: '1px solid $mauve6',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: '$blue9',
  }
});



export const CheckboxLabel = styled('span', {
  // color: '$mauve12',
  // fontWeight: 500,
});

export const CheckboxDescription = styled('span', {
  color: '$green11',
  fontSize: '$xs',
  fontWeight: 'bold',
  marginLeft: 'auto',
  background: '$green4',
  padding: '0.2rem 0.5rem',
  borderRadius: '99px',
});

export const LabelWrapper = styled('div', {
  display: 'flex', 
  alignItems: 'center',
  gap: '0.5rem',
})

export const QuestionIcon = styled(FaQuestionCircle, {
  cursor: 'pointer',
  color: '#aaa',
  fontSize: '0.9rem', 
  '&:hover': {
    color: '#555',
  },
})

export const ModalOverlay = styled('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '1rem',
})


export const ModalContent = styled('div', {
  background: 'white',
  borderRadius: '8px',
  padding: '1.5rem',
  width: '100%',
  maxWidth: '600px',
  maxHeight: '85vh',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
})

export const ModalHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1rem',
  '& h3': {
    margin: 0,
    fontSize: '1.25rem',
    color: '#333',
  },
})

export const CloseIcon = styled(FaTimes, {
  cursor: 'pointer',
  color: '#888',
  fontSize: '1.25rem',
  '&:hover': {
    color: '#000',
  },
})

export const ModalBody = styled('div', {
  overflowY: 'auto',
  flexGrow: 1,
})

export const ModalList = styled('ul', {
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
})

export const ModalListItem = styled('li', {
  background: '#f0f0f0',
  padding: '0.3rem 0.6rem',
  borderRadius: '4px',
  fontSize: '0.9rem',
  color: '#444',
})